var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.injections.components[_vm.props.aside.component],_vm._g(_vm._b({tag:"component"},'component',_vm.data.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }